import React from "react";
import request from "arcdynamic-request";
import {dateUStoISO, dateISOtoUS, dateToUsString} from "../../date-converter";
import {browserHistory} from "react-router";
import SellerDrawer from "../SellerDrawer/SellerDrawer";
import BuyerDrawer from "../BuyerDrawer/BuyerDrawer";
import FirmDrawer from "../FirmDrawer/FirmDrawer";
import AgentDrawer from "../AgentDrawer/AgentDrawer";
import Drawer from "../Drawer";
import {
    GET_ALL_TENANTS,
    PROPERTY_UNDERWRITING_TENANTS,
    ESCROW_TRACKING,
    PROPERTY_DATA, GET_PROPERTY_HISTORY,
} from "../../consts/queries";
import {
    PROPERTIES,
    UNDERWRITING_TENANTS,
    STRIVE_ESCROW_TRACKING,
    SELLERS, HSC_TRACKING, PROPERTY_HISTORY,
} from "../../consts/tables";
import {
    sendListedClosedEmail,
    sendNegotiationUnderContractEmail,
    sendDefaultEmail,
} from "../../requests/emailRequests";
import {env} from "../../consts/env";
import PropertyInfo from "./components/PropertyInfo";
import OwnershipInfo from "./components/OwnershipInfo";
import RepresentationAgreement from "./components/RepresentationAgreement";
import PropertyFinancials from "./components/PropertyFinancials";
import InNegotiationUnderContract from "./components/InNegotiationUnderContract";
import Financials from "../Financials";
import Website from "./components/Website";
import SaleInformation from "./components/SaleInformation";
import CRUD from "../CRUD";
import {executeQuery} from "../../requests/executeQuery";
import {getData, manageData} from "../../requests/CRUD";
import ListingAgent from "./components/ListingAgent";
import BuysideAgent from "./components/BuysideAgent";
import Dropdown from "../Dropdown/Dropdown";
import Loan from "./components/Loan";
import {pmtFunction} from "../UnderwritingSingleTenant/single-tenant-tables/constants";
import LenderDrawer from "../LenderDrawer/LenderDrawer";
import {apiBackOnMarketUrl, apiPriceChangeUrl} from "../../requests/apiBaseUrls";
import PropertyHistory from "./components/PropertyHistory";
import {CurrentHistoryModel, PropertyHistoryModel} from "../../models";

let cloneDeep = require("lodash.clonedeep");
let findIndex = require("lodash.findindex");
let find = require("lodash.find");

const defaultVisibleTenants = 5;

const priceProps = [
    "SQFT",
    "LIST_PRICE",
    "SOLD_PRICE",
    "NET_OPERATING_INCOME",
    "DOWN_PAYMENT",
    "TOTAL_FEE",
    "PRICE_PER_SQFT",
    "RENT_PER_SQFT",
    "CLOSE_PRICE_PER_SQFT",
    "CLOSE_NOI",
    "NEGOTIATION_PRICE",
    "POTENTIAL_FEE",
    "NEGOTIATION_PRICE_PER_SQFT",
    "BASE_RENT",
    "LIST_FEE",
    "BUYSIDE_FEE",
    "REFERRAL_FEE",
    "HSC_PRICE",
    "HSC_TOTAL_FEE",
    "HSC_LIST_FEE",
    "LOAN_AMOUNT",
    "ANNUAL_LOAN_PAYMENT",
    "CASH_FLOW",
    "CREDITS_AT_CLOSING",
    "REFERRAL"
];

const percentProps = [
    "VACANCY",
    "CAPITALIZATION_RATE",
    "SELLER_FEE_PERCENTAGE",
    "CLOSE_CAP_RATE",
    "NEGOTIATION_CAP_RATE",
    "LTV",
    "INTEREST_RATE",
    "CASH_ON_CASH",
    "DSCR",
    "REFERRAL_PERCENT",
    "HSC_FEE_PERCENTAGE",
];

const dateProps = [
    "LISTED_DATE",
    "EXPIRATION_DATE",
    "LEASE_COMMENCEMENT_DATE",
    "LEASE_EXPIRATION_DATE",
    "CLOSE_OF_ESCROW",
    "DATE_REMOVED",
    "DATE_CREATED",
    "LAST_MODIFIED_DATE",
    "MATURITY_DATE",
    "HSC_LISTED_DATE",
    "HSC_EXPIRATION_DATE",
];

const checkboxProps = [
    "STRIVE_SLIDER",
    "FEATURED",
    "VISIBLE",
    "HSC_FINANCING",
];

const agentKeyPercents = [
    "LISTING_AGENT_1_PERCENT",
    "LISTING_AGENT_2_PERCENT",
    "LISTING_AGENT_3_PERCENT",
    "LISTING_AGENT_4_PERCENT",
    "BUYER_AGENT_1_PERCENT",
    "BUYER_AGENT_2_PERCENT",
    "BUYER_AGENT_3_PERCENT",
    "BUYER_AGENT_4_PERCENT",
];

const sellerKeys = [
    "FIRST_NAME",
    "LAST_NAME",
    "PHONE",
    "EMAIL",
    "PROFILE",
    "NOTES",
    "COMPANY_NAME",
    "COMPANY_ADDRESS",
    "COMPANY_CITY",
    "COMPANY_STATE",
    "COMPANY_ZIP",
];

const excludedKeys = [
    'LISTING_AGENT_1_FIRST_NAME',
    'LISTING_AGENT_1_LAST_NAME',
    'LISTING_AGENT_4_FIRST_NAME',
    'LISTING_AGENT_4_LAST_NAME',
    'LISTING_AGENT_FIRM_NAME',
];

function pricePerFoot(priceStr, sqftStr) {
    const price = priceToInt(priceStr);
    const sqft = priceToInt(sqftStr);

    if (price && sqft) {
        return (Math.round((price / sqft) * 100) / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
    } else {
        return "";
    }
}

function rentPerFoot(priceStr, sqftStr, occupancyStr) {
    if (priceStr && sqftStr && occupancyStr) {
        const price = priceToInt(priceStr);
        const sqft = priceToInt(sqftStr);
        const occupancy = percentToNumber(occupancyStr);

        if (price && sqft && occupancy) {
            return (Math.round((price / (sqft * (occupancy / 100))) * 100) / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }
    }

    return "";
}

function percentToNumber(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/,/g, "").replace(/%$/, "");
        const num = Number(str);
        if (str && num === num) {
            // !isNaN
            return num;
        }
    }
    return false;
}

function percentToString(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/,/g, "").replace(/%$/, "");
        return str;
    }
    return false;
}

function priceToInt(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/\$|,/g, "");
        const num = Number(str);
        if (str && num === num) {
            // !isNaN
            return num;
        }
    }
    return false;
}

export function priceToString(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/\$|,/g, "");
        return str;
    }
    return false;
}

function convertDataToForm(dbData, withSeller) {
    const data = {...dbData};
    const seller = {};

    priceProps
        .filter((key) => data[key])
        .forEach((key) => {
            const num = Number(data[key]);
            if (num === num) {
                // !isNaN
                if (["TOTAL_FEE", "POTENTIAL_FEE", "LIST_FEE", "BUYSIDE_FEE"].includes(key)) {
                    data[key] = num.toLocaleString(undefined, {minimumFractionDigits: 2});
                } else {
                    data[key] = num.toLocaleString();
                }
            }
        });

    const price = data.SOURCE === 'HSC' ? data.HSC_PRICE : data.LIST_PRICE;
    const rentPrice = data.TYPE === 'MT' ? data.BASE_RENT : data.NET_OPERATING_INCOME;
    const occupancy = data.TYPE === 'MT' ? data.VACANCY : '100';
    data.PRICE_PER_SQFT = pricePerFoot(price, data.SQFT);
    data.RENT_PER_SQFT = rentPerFoot(rentPrice, data.SQFT, occupancy);
    data.CLOSE_PRICE_PER_SQFT = pricePerFoot(data.SOLD_PRICE, data.SQFT);
    data.NEGOTIATION_PRICE_PER_SQFT = pricePerFoot(data.NEGOTIATION_PRICE, data.SQFT);
    data.CREDITS_AT_CLOSING = !data.CREDITS_AT_CLOSING ? '0' : data.CREDITS_AT_CLOSING;

    dateProps
        .filter((key) => data[key])
        .forEach((key) => {
            const str = dateISOtoUS(data[key]);
            if (str !== false) {
                data[key] = str;
            }
        });

    checkboxProps
        .filter(key => data[key])
        .forEach(key => {
            data[key] = data[key] === 'y'
        });

    agentKeyPercents
        .filter((key) => data[key])
        .forEach((key) => {
            if (!parseFloat(data[key])) {
                data[key] = "";
            }
        });


    if (withSeller) {
        sellerKeys.forEach(key => {
            const sellerKey = `SELLER_${key}`;
            if (data.hasOwnProperty(sellerKey)) {
                seller[key] = data[sellerKey];
                delete data[sellerKey];
            }
        });

        return {data, seller};
    }

    return data;
}

function convertFormToData(formData) {
    const data = {...formData};

    // Convert money and locale number formatting to STRING
    priceProps.forEach((key) => {
        const num = priceToString(data[key]);
        if (num !== false) {
            data[key] = num;
        }
    });

    percentProps.forEach((key) => {
        const num = percentToString(data[key]);
        if (num !== false) {
            data[key] = num;
        }
    });

    dateProps
        .filter((key) => data[key])
        .forEach((key) => {
            const str = dateUStoISO(data[key]);
            if (str !== false) {
                data[key] = str;
            }
        });

    checkboxProps.forEach(key => {
        data[key] = data[key] ? 'y' : null
    });

    agentKeyPercents.forEach((key) => {
        const num = percentToString(data[key]);
        if (num !== false) {
            if (!parseFloat(data[key])) {
                data[key] = "0.000000000000000";
            } else {
                data[key] = num;
            }
        }
    });

    if (data.NET_OPERATING_INCOME && data.STATUS === "Closed" && !data.CLOSE_NOI) {
        data.CLOSE_NOI = data.NET_OPERATING_INCOME;
    }

    if (data.SOLD_PRICE && data.CLOSE_NOI) {
        data.CLOSE_CAP_RATE = Math.round((data.CLOSE_NOI / data.SOLD_PRICE) * 10000) / 100;
    }

    // Normalize
    Object.keys(data).forEach((key) => {
        // Trim whitespace
        if (typeof data[key] === "string") {
            data[key] = data[key].trim();
        }

        // Replace empty with null for consistency
        if (data[key] === "") {
            data[key] = null;
        }
    });

    return data;
}

function calculateExpirationDate({noMonths, listedDate}) {
    if (!noMonths || !listedDate) {
        return "";
    }
    const date = new Date(listedDate);
    const months = parseInt(noMonths);
    if (date) {
        date.setMonth(date.getMonth() + months);
    }
    return date ? dateToUsString(date) : "";
}

function setListingAgentsPercent(data, p1, p2, p3) {
    data.LISTING_AGENT_1_PERCENT = p1;
    data.LISTING_AGENT_2_PERCENT = p2;
    data.LISTING_AGENT_3_PERCENT = p3;
}

function setBuyingAgentsPercent(data, p1, p2, p3) {
    data.BUYER_AGENT_1_PERCENT = p1;
    data.BUYER_AGENT_2_PERCENT = p2;
    data.BUYER_AGENT_3_PERCENT = p3;
}

function changeListingAgentsPercent(oldData) {
    const data = {...oldData};
    const hasSplit = data.BUYER_AGENT_1 || data.BUYER_AGENT_2 || data.BUYER_AGENT_3 || data.BUYER_AGENT_4;

    if (data.LISTING_AGENT_1 && data.LISTING_AGENT_2 && data.LISTING_AGENT_3) {
        const p = hasSplit ? "16.66" : "33.33";
        setListingAgentsPercent(data, p, p, p);
    } else if (data.LISTING_AGENT_1 && data.LISTING_AGENT_2) {
        const p = hasSplit ? "25.00" : "50.00";
        setListingAgentsPercent(data, p, p, "0.00");
    } else if (data.LISTING_AGENT_1) {
        const p = hasSplit ? "50.00" : "100.00";
        setListingAgentsPercent(data, p, "0.00", "0.00");
    } else {
        setListingAgentsPercent(data, "0.00", "0.00", "0.00");
    }
    data.LISTING_AGENT_4_PERCENT = data.LISTING_AGENT_4 ? hasSplit ? "50.00" : "100.00" : "0.00";

    return data;
}

function changeBuyingAgentsPercent(oldData) {
    let data = {...oldData};

    if (data.BUYER_AGENT_1 && data.BUYER_AGENT_2 && data.BUYER_AGENT_3) {
        setBuyingAgentsPercent(data, "16.66", "16.66", "16.66");
    } else if (data.BUYER_AGENT_1 && data.BUYER_AGENT_2) {
        setBuyingAgentsPercent(data, "25.00", "25.00", "0.00");
    } else if (data.BUYER_AGENT_1) {
        setBuyingAgentsPercent(data, "50.00", "0.00", "0.00");
    } else {
        setBuyingAgentsPercent(data, "0.00", "0.00", "0.00");
    }
    data.BUYER_AGENT_4_PERCENT = data.BUYER_AGENT_4 ? "50.00" : "0.00";

    data = changeListingAgentsPercent(data);

    return data;
}

export default class CRUDProperty extends React.Component {
    currentPageRef;
    drawerComponentRef;

    constructor(props) {
        super(props);

        this.state = {
            data: null,
            original: null,
            previousData: null,
            seller: null,
            originalSeller: null,
            hasModifiedStatus: false,
            hasModifiedListPrice: false,
            hasReducedListPrice: false,
            isBusy: null,
            error: null,
            success: null,
            financialsSpreadsheetInView: false,
            currentUser: null,
            newPropertyId: null,
            allTenants: null,
            allTenantsById: null,
            tenantsBySQFT: null,
            showDrawer: false,
            addNewItemType: null,
            newSeller: null,
            newBuyer: null,
            newAgent: null,
            newFirm: null,
            newLender: null,
            errorTabs: [],
            currentTab: 0,
            viewMode: this.props.edit || false,
            sellerSelected: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.setDataFromFinancials = this.setDataFromFinancials.bind(this);
        this.openFinancialsSpreadsheet = this.openFinancialsSpreadsheet.bind(this);
        this.closeFinancialsSpreadsheet = this.closeFinancialsSpreadsheet.bind(this);
        this.setValue = this.setValue.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.handleSellerChangeDropdown = this.handleSellerChangeDropdown.bind(this);
        this.handleSellerChangeInput = this.handleSellerChangeInput.bind(this);
        this.addNewItem = this.addNewItem.bind(this);
        this.savedNewItem = this.savedNewItem.bind(this);
        this.checkCoordinatesAndSave = this.checkCoordinatesAndSave.bind(this);
        this.closeDrawer = this.closeDrawer.bind(this);
        this.getTenantsForTags = this.getTenantsForTags.bind(this);
        this.redirectToEscrowTracking = this.redirectToEscrowTracking.bind(this);
        this.redirectToHscTracking = this.redirectToHscTracking.bind(this);

        this.drawerComponentRef = React.createRef();
        this.currentPageRef = React.createRef();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params.id !== nextProps.params.id) {
            this.getProperty(nextProps.params.id);
        }
    }

    componentDidMount() {
        this.getProperty(this.props.params.id);
    }

    static excludeSellerData(resData) {
        const data = {...resData};
        sellerKeys.forEach(key => delete data[`SELLER_${key}`]);
        return data;
    }

    closeDrawer() {
        this.setState({showDrawer: false});
    }

    geocode(data, callback) {
        const xhr = new XMLHttpRequest();

        xhr.onload = (e) => {
            try {
                const res = JSON.parse(e.target.response);
                callback(res.results[0].geometry.location);
            } catch (e) {
                callback(null);
            }
        };
        xhr.onerror = () => {
            callback(null);
        };
        xhr.open("GET", "https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDjYXM4MFH059vLuf5mUgItastWFVrKzv4&address=" + encodeURIComponent(`${data.ADDRESS}, ${data.CITY}, ${data.STATE}`));
        xhr.send();
    }

    getProperty(id) {
        this.setState({
            data: null,
            original: null,
            error: null,
            success: null,
            currentUser: null,
        });

        const userName = this.props.userData.person.firstName + " " + this.props.userData.person.lastName;

        if (id === undefined) {
            request(arc.path.api, {
                service: "arcimedes",
                action: "open.dataquery.execute",
                params: [GET_ALL_TENANTS, {}],
            }).then((res) => {
                if (res && res.success && Array.isArray(res.data) && res.data.length) {
                    const allTenants = res.data;
                    const allTenantsById = [];
                    allTenants.forEach((x) => (allTenantsById[x.ARCIMEDES_ROW_ID] = x));

                    this.setState({
                        allTenants: allTenants,
                        allTenantsById: allTenantsById,
                    });
                }
            });

            const data = {
                DATE_CREATED: new Date().toLocaleDateString("en-US"),
                CREATED_BY: userName,
                TRANSACTION_TYPE: "Investment Sales",
                LAST_MODIFIED_BY: userName,
                LAST_MODIFIED_DATE: new Date().toLocaleDateString("en-US"),
                FEATURED: "y",
                LISTING_AGENT_1_PERCENT: "",
                LISTING_AGENT_2_PERCENT: "",
                LISTING_AGENT_3_PERCENT: "",
                LISTING_AGENT_4_PERCENT: "",
                BUYER_AGENT_1_PERCENT: "",
                BUYER_AGENT_2_PERCENT: "",
                BUYER_AGENT_3_PERCENT: "",
                BUYER_AGENT_4_PERCENT: "",
                CREDITS_AT_CLOSING: '0',
            };

            this.setState({
                data: data,
                original: {},
                seller: {},
                originalSeller: {},
                currentUser: userName,
                financialsSpreadsheetInView: this.props.isAgent,
            });
            return;
        }

        Promise.all([
            executeQuery({queryName: PROPERTY_DATA,
                params: {
                    PROPERTY_ID: id,
                },
            }),
            request(arc.path.api, {
                service: "arcimedes",
                action: "open.dataquery.execute",
                params: [PROPERTY_UNDERWRITING_TENANTS, {
                    param: {
                        PROPERTY_ID: id,
                    },
                },],
            }),
            request(arc.path.api, {
                service: "arcimedes",
                action: "open.dataquery.execute",
                params: [GET_ALL_TENANTS, {}],
            }),
            executeQuery({queryName: GET_PROPERTY_HISTORY,
                params: {
                    PROPERTY_ID: id,
                },
            }),
        ]).then((res) => {
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) && res[0].data.length) {
                let {data, seller} = convertDataToForm(res[0].data[0], true);
                // Verify if Tenants are saved in Underwriting Tenants Table too (just for Multi Tenant Properties)
                if (res[1] && res[1].success && Array.isArray(res[1].data) &&
                    res[2] && res[2].success && Array.isArray(res[2].data) && res[2].data.length) {
                    const underwritingTenants = res[1].data;
                    const allTenants = res[2].data;
                    const tenantIds = data.TENANT_ID ? data.TENANT_ID.split(",") : [];
                    let newTenants = [];
                    const allTenantsById = [];
                    allTenants.forEach((x) => (allTenantsById[x.ARCIMEDES_ROW_ID] = x));
                    let index = 0;
                    tenantIds.map((tenantId) => {
                        const existingTenant = findIndex(underwritingTenants, {
                            TENANT_ID: tenantId,
                        });
                        if (existingTenant === -1 && allTenantsById[tenantId]) {
                            const tenantName = allTenantsById[tenantId].NAME;
                            newTenants.push({
                                PROPERTY_ID: id,
                                TENANT_ID: tenantId,
                                TENANT_NAME: tenantName,
                                TENANT_ROW_ID: index,
                            });
                            index++;
                        }
                    });
                    if (newTenants.length > 0) {
                        this.saveUnderwritingTenants(newTenants);
                    }
                    this.setState({
                        allTenants: allTenants,
                        allTenantsById: allTenantsById,
                        tenantsBySQFT: underwritingTenants,
                    });
                }

                const currentData = new CurrentHistoryModel(res[0].data[0]);
                const historyData = res[3] && res[3].success && Array.isArray(res[3].data) && res[3].data.length ? [...res[3].data, currentData] : [currentData];

                this.setState({
                    financialsSpreadsheetInView: this.props.isAgent,
                    data: data,
                    original: CRUDProperty.excludeSellerData(res[0].data[0]),
                    historyData: historyData,
                    seller: seller,
                    originalSeller: {...seller},
                    currentUser: userName,
                    error: null,
                });
            } else {
                this.setState({
                    data: false,
                    original: false,
                    seller: false,
                    originalSeller: false,
                    error: res[0].message ? res[0].message : "Unidentified Error",
                });
            }
        });
    }

    saveUnderwritingTenants(tenants) {
        request(arc.path.api, {
            service: "arcimedes",
            action: "open.datasource.table.Data.updateByTableCode",
            params: [UNDERWRITING_TENANTS, {
                value: tenants,
            },],
        }).then((result) => {
            if (!result || !result.success) {
                this.setState({
                    error: result.message ? result.message : "Unidentified Error",
                });
            }
        });
    }

    static editTrackingTask(data, task, key, substringStart, substringEnd) {
        let newTask = cloneDeep(task);
        const str = newTask.substring(substringStart, substringEnd);
        if (str) {
            newTask = newTask.replace(str, data[key] ? data[key] : "");
        } else {
            newTask = newTask.split("");
            newTask.splice(substringStart, 0, data[key] ? data[key] : "");
            newTask = newTask.join("");
        }
        return newTask;
    }

    fetchSeller() {
        request(arc.path.api, {
            service: "arcimedes",
            action: "open.datasource.table.Data.getData",
            params: ["code", SELLERS, {
                filter: [{
                    text: this.state.data.SELLER_ID,
                    code: "ARCIMEDES_ROW_ID",
                    type: "exact",
                },],
            },],
        }).then((res) => {
            if (res && res.success && Array.isArray(res.data) && res.data.length) {
                const seller = {};
                sellerKeys.forEach(key => {
                   seller[key] = res.data[0][key];
                });
                this.setState({
                    seller,
                    originalSeller: {...seller},
                    sellerSelected: false,
                    error: null,
                });
            } else {
                this.setState({
                    data: false,
                    error: res.message ? res.message : "Unidentified Error",
                });
            }
        });
    }

    static updatePropertyData({data, oldData, original, isEscrow}) {
        const newData = {
            PROPERTY_ID: oldData.ARCIMEDES_ROW_ID,
        };

        if (isEscrow) {
            if (data.hasOwnProperty("BUYER_ID")) {
                newData.BUYER = data.BUYER_ID;
            }
            if (data.hasOwnProperty("BUYER_AGENT_1")) {
                newData.BUYING_AGENT_1 = data.BUYER_AGENT_1;
            }
            if (data.hasOwnProperty("BUYER_AGENT_4")) {
                newData.BUYING_AGENT_4 = data.BUYER_AGENT_4;
            }
            if (data.hasOwnProperty("BUYER_AGENT_4_FIRM")) {
                newData.BUYING_AGENT_FIRM = data.BUYER_AGENT_4_FIRM;
            }
        }

        let task = `${original.NAME} - ${original.CITY ? original.CITY : ""}, ${original.STATE ? original.STATE : ""}`;
        if (data.hasOwnProperty("NAME")) {
            task = CRUDProperty.editTrackingTask(data, task, "NAME", 0, task.indexOf("-") - 1);
        }
        if (data.hasOwnProperty("CITY")) {
            task = CRUDProperty.editTrackingTask(data, task, "CITY", task.indexOf("-") + 2, task.indexOf(","));
        }
        if (data.hasOwnProperty("STATE")) {
            task = CRUDProperty.editTrackingTask(data, task, "STATE", task.indexOf(",") + 2, task.length);
        }
        newData.TASK = task;

        return newData;
    }

    async fetchEscrowData(data) {
        let inEscrow = false;
        const propertyInEscrow = await this.getPropertyEscrowTracking(this.state.data.ARCIMEDES_ROW_ID);
        const oldData = this.state.data;
        const striveID = !env ? "34" : "2";

        // In Escrow if source is STRIVE & status is Under Contract
        // 		  or if source is External & status is Under Contract & Listing/Buyer Agent 4 Firm is STRIVE
        if ((oldData.SOURCE === "STRIVE" && oldData.STATUS === "Under Contract") ||
            (oldData.SOURCE === "External" && oldData.STATUS === "Under Contract" &&
                (oldData.LISTING_AGENT_4_FIRM === striveID || oldData.BUYER_AGENT_4_FIRM === striveID))) {
            inEscrow = true;
        }

        // Add property to STRIVE Escrow Tracking
        if (inEscrow && oldData.ARCIMEDES_ROW_ID &&
            (!propertyInEscrow || !propertyInEscrow.ARCIMEDES_ROW_ID || propertyInEscrow.DELETED === "1")) {
            let newData = {
                PROPERTY_ID: oldData.ARCIMEDES_ROW_ID,
                TASK: `${oldData.NAME} - ${oldData.CITY ? oldData.CITY : ""}, ${oldData.STATE ? oldData.STATE : ""}`,
                BUYER: oldData.BUYER_ID,
                BUYING_AGENT_1: oldData.BUYER_AGENT_1,
                BUYING_AGENT_4: oldData.BUYER_AGENT_4,
                BUYING_AGENT_FIRM: oldData.BUYER_AGENT_4_FIRM,
                DELETED: null,
            };
            this.updatePropertyTracking(newData, STRIVE_ESCROW_TRACKING);
        }

        // Update property info in STRIVE Escrow Tracking
        if (propertyInEscrow && propertyInEscrow.ARCIMEDES_ROW_ID && propertyInEscrow.DELETED !== "1" && oldData.ARCIMEDES_ROW_ID &&
            (data.hasOwnProperty("BUYER_ID") || data.hasOwnProperty("BUYER_AGENT_1") || data.hasOwnProperty("BUYER_AGENT_4")
                || data.hasOwnProperty("BUYER_AGENT_4_FIRM") || data.hasOwnProperty("NAME") || data.hasOwnProperty("CITY") || data.hasOwnProperty("STATE"))) {
            const original = this.state.original;
            const newData = CRUDProperty.updatePropertyData({data, oldData, original, isEscrow: true});
            this.updatePropertyTracking(newData, STRIVE_ESCROW_TRACKING);
        }

        // Remove property from STRIVE Escrow Tracking
        if ((!inEscrow && propertyInEscrow && propertyInEscrow.ARCIMEDES_ROW_ID && propertyInEscrow.DELETED !== "1")
            || oldData.DELETED === "1") {
            const data = {
                PROPERTY_ID: this.state.data.ARCIMEDES_ROW_ID,
                DELETED: "1",
            };
            this.updatePropertyTracking(data, STRIVE_ESCROW_TRACKING);
        }
    }

    async fetchHscTrackingData(data) {
        let tracking = false;
        const property = await this.getPropertyHscTracking(this.state.data.ARCIMEDES_ROW_ID);
        const oldData = this.state.data;

        // Tracking if (source is HSC or is HSC financing) & status is Courting/Loan In Process
        if ((oldData.SOURCE === 'HSC' || oldData.HSC_FINANCING) && ['Courting', 'Loan In Process'].includes(oldData.HSC_STATUS)) {
            tracking = true;
        }

        // Add property to HSC Tracking
        if (tracking && oldData.ARCIMEDES_ROW_ID &&
            (!property || !property.ARCIMEDES_ROW_ID || property.DELETED === '1')) {
            let newData = {
                PROPERTY_ID: oldData.ARCIMEDES_ROW_ID,
                TASK: `${oldData.NAME} - ${oldData.CITY ? oldData.CITY : ''}, ${oldData.STATE ? oldData.STATE : ''}`,
                DELETED: null,
            };
            this.updatePropertyTracking(newData, HSC_TRACKING);
        }

        // Update property info in HSC Tracking
        if (property && property.ARCIMEDES_ROW_ID && property.DELETED !== '1' && oldData.ARCIMEDES_ROW_ID &&
            (data.hasOwnProperty('NAME') || data.hasOwnProperty('CITY') || data.hasOwnProperty('STATE'))) {
            const original = this.state.original;
            const newData = CRUDProperty.updatePropertyData({data, oldData, original});
            this.updatePropertyTracking(newData, HSC_TRACKING);
        }

        // Remove property from HSC Tracking
        if ((!tracking && property && property.ARCIMEDES_ROW_ID && property.DELETED !== '1') || oldData.DELETED === '1') {
            const data = {
                PROPERTY_ID: this.state.data.ARCIMEDES_ROW_ID,
                DELETED: '1',
            };
            this.updatePropertyTracking(data, HSC_TRACKING);
        }
    }

    async saveData(newData) {
        let data = {};
        const seller = {...this.state.seller};

        if (newData) {
            data = convertFormToData(newData);
        } else {
            data = convertFormToData(this.state.data);
        }

        if (this.state.currentUser && this.state.currentUser !== data.LAST_MODIFIED_BY) {
            data.LAST_MODIFIED_BY = this.state.currentUser;
            data.LAST_MODIFIED_DATE = new Date().toISOString().split("T")[0];
        }

        if (this.state.original["STATUS"] !== data["STATUS"])
            this.setState({hasModifiedStatus: true});

        if (this.state.original.LIST_PRICE !== data.LIST_PRICE)
            this.setState({hasModifiedListPrice: true});

        if (this.state.original.LIST_PRICE > data.LIST_PRICE)
            this.setState({hasReducedListPrice: true});

        if (this.state.original["STATUS"] !== "Off Market" && data["STATUS"] === "Off Market") {
            data.OFF_MARKET_SINCE = new Date().toISOString().split("T")[0];
        }

        if (["Active", "Closed"].includes(this.state.original["STATUS"]) && ["Under Contract", "In Negotiation"].includes(data["STATUS"])) {
            data.UNDER_CONTRACT_IN_NEGOTIATION_SINCE = new Date().toISOString().split("T")[0];
        } else if (["Under Contract", "In Negotiation"].includes(this.state.original["STATUS"]) && ["Active", "Closed"].includes(data["STATUS"])
            && this.state.original.UNDER_CONTRACT_IN_NEGOTIATION_SINCE && data.EXPIRATION_DATE) {
            const lastModifiedDate = new Date(this.state.original.UNDER_CONTRACT_IN_NEGOTIATION_SINCE);
            const today = new Date();

            // Calculate how many days a property spent in a status of 'Under Contract' or 'In Negotiation'
            const diffDays = Math.floor(Math.abs(today - lastModifiedDate) / (1000 * 60 * 60 * 24));
            const expiringDate = new Date(data.EXPIRATION_DATE);
            expiringDate.setDate(expiringDate.getDate() + diffDays);
            data.EXPIRATION_DATE = expiringDate.toISOString().split("T")[0];
        }

        if (!data.IS_LISTING && ["Active", "In Negotiation", "Under Contract", "Removed"].includes(data.STATUS)) {
            data.IS_LISTING = 1;
        }

        if (data.IS_LISTING === "1" && ["Closed", "Off Market"].includes(data.STATUS)) {
            data.IS_LISTING = 0;
        }

        if (!data.WAS_PROPOSAL && data.STATUS === "Proposal") {
            data.WAS_PROPOSAL = 1;
        }

        // Discard unchanged values
        Object.keys(data).forEach((key) => {
            if (this.state.original.hasOwnProperty(key) && data[key] === this.state.original[key] || excludedKeys.includes(key))
                delete data[key];
        });
        Object.keys(seller).forEach((key) => {
            if (this.state.originalSeller.hasOwnProperty(key) && seller[key] === this.state.originalSeller[key])
                delete seller[key];
        });

        // No changes detected, nothing to do
        if (!Object.keys(data).length && !Object.keys(seller).length) {
            this.setState({
                isBusy: null,
                error: null,
                success: "No data to update",
            });
            window.scrollTo(0, 0);
            return;
        }

        this.setState({
            isBusy: true,
            error: null,
            success: null,
        });

        await this.fetchEscrowData(data);
        await this.fetchHscTrackingData(data);

        if (this.props.params.id) {
            data.ARCIMEDES_ROW_ID = this.props.params.id;
        } else {
            if (this.state.newPropertyId) {
                data.ARCIMEDES_ROW_ID = this.state.newPropertyId;
            }
        }

        return Promise.all([
            manageData({
                tableCode: PROPERTIES,
                data: [data],
            }),
            this.props.edit && Object.keys(seller).length &&
                manageData({
                    tableCode: SELLERS,
                    data: [{
                        ARCIMEDES_ROW_ID: this.state.data.SELLER_ID,
                        ...seller,
                    }],
                }),
        ]).then((res) => {
            if (res && res[0] && res[0].success && res[1] && res[1].success) {
                // changes in both property & seller
                this.setState((prevState) => ({
                    isBusy: null,
                    success: "Saved",
                    previousData: prevState.original,
                    data: convertDataToForm(res[0].data[0]),
                    original: {...res[0].data[0]},
                    seller: {...res[1].data[0]},
                    originalSeller: {...res[1].data[0]},
                    newPropertyId: null,
                }), () => {
                    if (!this.props.edit) {
                        // redirect from add
                        browserHistory.push({pathname: `/property/${res[0].data[0].ARCIMEDES_ROW_ID}`});
                    }
                    window.scrollTo(0, 0);
                });
            } else if (res && res[0] && res[0].success) {
                // changes in property
                this.setState((prevState) => ({
                    isBusy: null,
                    success: "Saved",
                    previousData: prevState.original,
                    data: convertDataToForm(res[0].data[0]),
                    original: {...res[0].data[0]},
                    newPropertyId: null,
                }), () => {
                    if (!this.props.edit) {
                        // redirect from add
                        browserHistory.push({pathname: `/property/${res[0].data[0].ARCIMEDES_ROW_ID}`});
                    } else {
                        // new seller selected, get seller data
                        res[0].data[0].SELLER_ID && this.state.sellerSelected && this.fetchSeller();
                    }
                    window.scrollTo(0, 0);
                });
            } else if (res && res[1] && res[1].success) {
                // changes in seller
                this.setState(() => ({
                    isBusy: null,
                    success: "Saved",
                    seller: {...res[1].data[0]},
                    originalSeller: {...res[1].data[0]},
                    newPropertyId: null,
                }), () => {
                    if (!this.props.edit) {
                        // redirect from add
                        browserHistory.push({pathname: `/property/${res[0].data[0].ARCIMEDES_ROW_ID}`});
                    }
                    window.scrollTo(0, 0);
                });
            } else {
                this.setState({
                    isBusy: null,
                    error: res[1] && res[1].message ? res[1].message : "Unspecified error",
                });
            }
            return {
                success: res[0].success,
                property: res[0].data[0],
            };
        }).then((res) => {
            if (!this.props.params.id) {
                this.fetchEscrowData(res.property);
                this.fetchHscTrackingData(res.property);
            }
            if (res.success) {
                const previousStatus = this.state.previousData.STATUS ? this.state.previousData.STATUS : null;
                if (this.state.hasModifiedStatus && ['Active', 'Closed', 'Removed'].includes(previousStatus) && ['Active', 'Closed', 'Removed'].includes(res.property.STATUS)
                    || !this.state.hasModifiedStatus && this.state.hasModifiedListPrice && res.property.STATUS === 'Active') {
                    this.savePropertyHistory(this.state.previousData);
                }
                if (this.state.hasModifiedStatus && res.property.SOURCE === "STRIVE" && res.property.STATUS === "Active" && ["Property Info", "Proposal", ""].includes(previousStatus)
                    || this.state.hasModifiedStatus && res.property.SOURCE === "STRIVE" && res.property.STATUS === "Closed") {
                    sendListedClosedEmail(res.property);
                }
                if (this.state.hasModifiedStatus && res.property.SOURCE === "STRIVE" && ["In Negotiation", "Under Contract"].includes(res.property.STATUS)) {
                    sendNegotiationUnderContractEmail(res.property);
                }
                if (this.state.hasReducedListPrice && res.property.SOURCE === 'STRIVE' && ['Active', 'In Negotiation', 'Under Contract'].includes(res.property.STATUS)) {
                    sendDefaultEmail(res.property, apiPriceChangeUrl);
                }
                if (this.state.hasModifiedStatus && res.property.SOURCE === 'STRIVE' && res.property.STATUS === 'Active' && ['In Negotiation', 'Under Contract'].includes(previousStatus)) {
                    sendDefaultEmail(res.property, apiBackOnMarketUrl);
                }
            }

            this.setState({
                hasModifiedStatus: false,
                hasModifiedListPrice: false,
                hasReducedListPrice: false,
            });
        });
    }

    savePropertyHistory(property) {
        const data = new PropertyHistoryModel(property);
        manageData({tableCode: PROPERTY_HISTORY, data: [data]}).then(res => {
            if (!res || !res.success) {
                this.setState({
                    error: res && res.message ? res.message : "Unspecified error",
                });
            } else {
                Promise.all([
                    executeQuery({queryName: GET_PROPERTY_HISTORY,
                        params: {
                            PROPERTY_ID: property.ARCIMEDES_ROW_ID,
                        },
                    }),
                    executeQuery({queryName: PROPERTY_DATA,
                        params: {
                            PROPERTY_ID: property.ARCIMEDES_ROW_ID,
                        },
                    })
                ]).then(res => {
                    let historyData = [];
                    if (res && res[0] && res[0].success && Array.isArray(res[0].data) && res[0].data.length)
                        historyData = [...res[0].data];
                    if (res && res[1] && res[1].success && Array.isArray(res[1].data) && res[1].data.length)
                        historyData.push(new CurrentHistoryModel(res[1].data[0]));
                    this.setState({
                        historyData,
                    });
                });
            }
        });
    }

    updatePropertyTracking(data, table) {
        manageData({tableCode: table, data: [data]}).then(res => {
            if (!res || !res.success)
                this.setState({
                    error: res && res.message ? res.message : "Unspecified error",
                });
        });
    }

    async getPropertyEscrowTracking(propertyId) {
        const res = await request(arc.path.api, {
            service: "arcimedes",
            action: "open.dataquery.execute",
            params: [ESCROW_TRACKING, {param: {PROPERTY_ID: propertyId}}],
        });

        if (res && res.success && Array.isArray(res.data) && res.data.length)
            return res.data[0];
        return null;
    }

    async getPropertyHscTracking(propertyId) {
        const options = {
            filter: [{
                'text': propertyId,
                'code': 'PROPERTY_ID',
                'type': 'exact',
            }],
        };
        const res = await getData({tableCode: HSC_TRACKING, options});

        if (res && res.success && Array.isArray(res.data) && res.data.length)
            return res.data[0];
        return null;
    }

    static verifyPercentDecimalsLimit({value, isAgentPercent}) {
        if (isAgentPercent) {
            const number = value.split(".");
            const decimals = number[1] ? number[1].length : null;
            if (decimals && decimals > 15) {
                return true;
            }
        }
        return false;
    }

    checkCoordinatesAndSave(data, original) {
        if (!data.ADDRESS || !data.CITY || !data.STATE) {
            data.LATITUDE = null;
            data.LONGITUDE = null;
            this.saveData(data);
        } else if (data.ADDRESS !== original.ADDRESS || data.CITY !== original.CITY || data.STATE !== original.STATE || !original.LATITUDE || !original.LONGITUDE) {
            this.geocode(data, (geo) => {
                data.LATITUDE = geo ? geo.lat : null;
                data.LONGITUDE = geo ? geo.lng : null;
                this.saveData(data);
            });
        } else {
            this.saveData(data);
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        if (this.state.viewMode) this.setState({viewMode: false});

        if (this.state.data.NAME === undefined || this.state.data.NAME === "") {
            this.setState({errorTabs: [0], success: null});
            return;
        } else {
            this.setState({errorTabs: []});
        }

        if (this.state.isBusy || this.state.viewMode === true) return;

        const data = this.state.data;
        const original = this.state.original;

        this.setState({viewMode: true}, () =>
            this.checkCoordinatesAndSave(data, original)
        );
    }

    setData(key, value, isAgentPercent = false, addAdditionalData = false, additionalDataValue = null) {
        let data = {...this.state.data};
        let closeNoiChanged = false, soldPriceChanged = false, hscPriceChanged = false, loanPaymentChanged = false,
            cashFlowChanged = false, downPaymentChanged = false, hscTotalFeeChanged = false;
        const exceededDecimalsLimit = CRUDProperty.verifyPercentDecimalsLimit({value, isAgentPercent});

        if (!exceededDecimalsLimit) {
            data = {...data, [key]: value};
        }

        if (key === 'STATUS' && value === 'Closed' && data.SOURCE === 'STRIVE')
            data.HSC_STATUS = data.STATUS;

        if (key === "SOURCE") {
            data.LISTING_AGENT_4_FIRM = value === "STRIVE" ? (!env ? "34" : "2") : "";
        }

        if (key === 'TYPE' && value === 'STNL') {
            data.VACANCY = 100;
        }

        if (key === "SQFT" || key === "LIST_PRICE") {
            data.PRICE_PER_SQFT = pricePerFoot(data.LIST_PRICE, data.SQFT);
        }

        if (key === "SQFT" || key === "NEGOTIATION_PRICE") {
            data.NEGOTIATION_PRICE_PER_SQFT = pricePerFoot(data.NEGOTIATION_PRICE, data.SQFT);
        }

        if (key === "SQFT" || key === "BASE_RENT" || key === 'NET_OPERATING_INCOME' || key === "VACANCY") {
            const price = data.TYPE === 'MT' ? data.BASE_RENT : data.NET_OPERATING_INCOME;
            const occupancy = data.TYPE === 'MT' ? data.VACANCY : '100';
            data.RENT_PER_SQFT = rentPerFoot(price, data.SQFT, occupancy);
        }

        if (key === 'NET_OPERATING_INCOME') {
            data.BASE_RENT = data.NET_OPERATING_INCOME;
        }

        if ((key === 'NET_OPERATING_INCOME' || key === 'STATUS') && data.STATUS === 'Closed' || key === 'CLOSE_OF_ESCROW') {
            data.CLOSE_NOI = data.NET_OPERATING_INCOME;
            closeNoiChanged = true;
        }

        if ((key === 'NEGOTIATION_PRICE' || key === 'STATUS') && data.STATUS === 'Closed' || key === 'CLOSE_OF_ESCROW') {
            data.SOLD_PRICE = data.SOURCE === 'HSC' ? data.HSC_PRICE : data.NEGOTIATION_PRICE;
            soldPriceChanged = true;
        }

        if (key === "NEGOTIATION_PRICE" || key === "NET_OPERATING_INCOME") {
            const price = priceToInt(data.NEGOTIATION_PRICE);
            const noi = priceToInt(data.NET_OPERATING_INCOME);
            data.NEGOTIATION_CAP_RATE = noi !== false && price !== false ? price ? Math.round((noi / price) * 10000) / 100 : 0 : "";
        }

        if (key === "SOLD_PRICE" || key === "CLOSE_NOI" || closeNoiChanged || soldPriceChanged) {
            const price = priceToInt(data.SOLD_PRICE);
            const noi = priceToInt(data.CLOSE_NOI);
            data.CLOSE_CAP_RATE = noi !== false && price !== false ? price ? Math.round((noi / price) * 10000) / 100 : 0 : "";
        }

        if (key === 'SQFT' || key === 'SOLD_PRICE' || soldPriceChanged) {
            data.CLOSE_PRICE_PER_SQFT = pricePerFoot(data.SOLD_PRICE, data.SQFT);
        }

        if (["LISTING_AGENT_1", "LISTING_AGENT_2", "LISTING_AGENT_3", "LISTING_AGENT_4",].indexOf(key) !== -1) {
            data = changeListingAgentsPercent(data);
        }

        if (["BUYER_AGENT_1", "BUYER_AGENT_2", "BUYER_AGENT_3", "BUYER_AGENT_4",].indexOf(key) !== -1) {
            data = changeBuyingAgentsPercent(data);
        }

        if (["LIST_PRICE", "SELLER_FEE_PERCENTAGE"].indexOf(key) !== -1) {
            const price = priceToInt(data.LIST_PRICE);
            const percent = percentToNumber(data.SELLER_FEE_PERCENTAGE);
            data.TOTAL_FEE = price !== false && percent !== false ? (price * (percent / 100)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2,}) : "";
        }

        if (soldPriceChanged ||
            ["SOLD_PRICE", "NEGOTIATION_PRICE", "SELLER_FEE_PERCENTAGE", "LISTING_AGENT_1", "LISTING_AGENT_2", "LISTING_AGENT_3", "LISTING_AGENT_4",
                "BUYER_AGENT_1", "BUYER_AGENT_2", "BUYER_AGENT_3", "BUYER_AGENT_4",
                "LISTING_AGENT_1_PERCENT", "LISTING_AGENT_2_PERCENT", "LISTING_AGENT_3_PERCENT", "LISTING_AGENT_4_PERCENT",
                "BUYER_AGENT_1_PERCENT", "BUYER_AGENT_2_PERCENT", "BUYER_AGENT_3_PERCENT", "BUYER_AGENT_4_PERCENT",].indexOf(key) !== -1) {
            const price = data.SOLD_PRICE ? priceToInt(data.SOLD_PRICE) : priceToInt(data.NEGOTIATION_PRICE);
            const feePercent = percentToNumber(data.SELLER_FEE_PERCENTAGE);
            const strivePercents = percentToNumber(data.LISTING_AGENT_1_PERCENT) + percentToNumber(data.LISTING_AGENT_2_PERCENT) + percentToNumber(data.LISTING_AGENT_3_PERCENT) + percentToNumber(data.BUYER_AGENT_1_PERCENT) + percentToNumber(data.BUYER_AGENT_2_PERCENT) + percentToNumber(data.BUYER_AGENT_3_PERCENT);
            data.POTENTIAL_FEE = price !== false && feePercent !== false && strivePercents ? (price * (feePercent / 100) * (strivePercents / 100)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2,}) : "";
        }

        if (soldPriceChanged ||
            ["SOLD_PRICE", "SELLER_FEE_PERCENTAGE", "LISTING_AGENT_1", "LISTING_AGENT_2", "LISTING_AGENT_3",
                "LISTING_AGENT_1_PERCENT", "LISTING_AGENT_2_PERCENT", "LISTING_AGENT_3_PERCENT", "LISTING_AGENT_4_PERCENT",
                "BUYER_AGENT_1", "BUYER_AGENT_2", "BUYER_AGENT_3", "BUYER_AGENT_4",].indexOf(key) !== -1) {
            const soldPrice = priceToInt(data.SOLD_PRICE);
            const feePercent = percentToNumber(data.SELLER_FEE_PERCENTAGE);
            const listAgentsPercent = percentToNumber(data.LISTING_AGENT_1_PERCENT) + percentToNumber(data.LISTING_AGENT_2_PERCENT) + percentToNumber(data.LISTING_AGENT_3_PERCENT) + percentToNumber(data.LISTING_AGENT_4_PERCENT);
            data.LIST_FEE = soldPrice !== false && feePercent !== false && listAgentsPercent ? (soldPrice * (feePercent / 100) * (listAgentsPercent / 100)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2,}) : "";
        }

        if (soldPriceChanged ||
            ["SOLD_PRICE", "SELLER_FEE_PERCENTAGE", "BUYER_AGENT_1", "BUYER_AGENT_2", "BUYER_AGENT_3", "BUYER_AGENT_4",
                "BUYER_AGENT_1_PERCENT", "BUYER_AGENT_2_PERCENT", "BUYER_AGENT_3_PERCENT", "BUYER_AGENT_4_PERCENT",
                "LISTING_AGENT_1", "LISTING_AGENT_2", "LISTING_AGENT_3",].indexOf(key) !== -1) {
            const soldPrice = priceToInt(data.SOLD_PRICE);
            const feePercent = percentToNumber(data.SELLER_FEE_PERCENTAGE);
            const buyingAgentsPercent = percentToNumber(data.BUYER_AGENT_1_PERCENT) + percentToNumber(data.BUYER_AGENT_2_PERCENT) + percentToNumber(data.BUYER_AGENT_3_PERCENT) + percentToNumber(data.BUYER_AGENT_4_PERCENT);
            data.BUYSIDE_FEE = soldPrice !== false && feePercent !== false && buyingAgentsPercent ? (soldPrice * (feePercent / 100) * (buyingAgentsPercent / 100)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2,}) : "";
        }

        if (["EXPIRATION_NO_OF_MONTHS", "LISTED_DATE"].indexOf(key) !== -1) {
            data.EXPIRATION_DATE = calculateExpirationDate({noMonths: data.EXPIRATION_NO_OF_MONTHS, listedDate: data.LISTED_DATE});
        }

        if ('SOURCE' === key && value === 'HSC') {
            data.TRANSACTION_TYPE = 'Financing';
            data.HSC_EXPIRATION_NO_OF_MONTHS = '6';
        }

        if (["HSC_EXPIRATION_NO_OF_MONTHS", "HSC_LISTED_DATE"].indexOf(key) !== -1) {
            data.HSC_EXPIRATION_DATE = calculateExpirationDate({noMonths: data.HSC_EXPIRATION_NO_OF_MONTHS, listedDate: data.HSC_LISTED_DATE});
        }

        if (data.HSC_FINANCING && (!data.HSC_PRICE || soldPriceChanged || ['SOLD_PRICE', 'NEGOTIATION_PRICE'].includes(key))) {
            data.HSC_PRICE = data.STATUS === 'Closed' ? data.SOLD_PRICE : data.NEGOTIATION_PRICE;
            hscPriceChanged = true;
        }

        if (data.SOURCE === 'HSC' && ['HSC_PRICE', 'NET_OPERATING_INCOME'].includes(key)) {
            const price = priceToInt(data.HSC_PRICE);
            const noi = priceToInt(data.NET_OPERATING_INCOME);
            data.CAPITALIZATION_RATE = price !== false && noi !== false ? (noi / price * 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';
        }

        if (hscPriceChanged || ['HSC_PRICE', 'LOAN_AMOUNT'].includes(key)) {
            const price = priceToInt(data.HSC_PRICE);
            const loanAmount = priceToInt(data.LOAN_AMOUNT);
            data.LTV = price !== false && loanAmount !== false ? (loanAmount / price * 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';
            data.DOWN_PAYMENT = price !== false && loanAmount !== false ? (price - loanAmount).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0}) : '';
            downPaymentChanged = true;
        }

        if (['HSC_PRICE', 'SQFT'].includes(key)) {
            data.PRICE_PER_SQFT = pricePerFoot(data.HSC_PRICE, data.SQFT);
        }

        if (['HSC_FEE_PERCENTAGE', 'LOAN_AMOUNT'].includes(key)) {
            const loanAmount = priceToInt(data.LOAN_AMOUNT);
            const percent = percentToNumber(data.HSC_FEE_PERCENTAGE);
            data.HSC_TOTAL_FEE = loanAmount !== false && percent !== false ? (loanAmount * (percent / 100)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : "";
            hscTotalFeeChanged = true;
        }

        if (hscTotalFeeChanged || ['REFERRAL', 'CREDITS_AT_CLOSING'].includes(key)) {
            const hscTotalFee = priceToInt(data.HSC_TOTAL_FEE);
            const referral = data.REFERRAL ? priceToInt(data.REFERRAL) : 0;
            const credits = data.CREDITS_AT_CLOSING ? priceToInt(data.CREDITS_AT_CLOSING) : 0;
            data.HSC_LIST_FEE = hscTotalFee !== false && referral !== false && credits !== false ? (hscTotalFee - referral - credits).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : "";
        }

        if (hscTotalFeeChanged || 'REFERRAL' === key) {
            const hscTotalFee = priceToInt(data.HSC_TOTAL_FEE);
            const referral = priceToInt(data.REFERRAL);
            data.REFERRAL_PERCENT = hscTotalFee !== false && referral !== false ? (referral / hscTotalFee * 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';
        }

        if (['INTEREST_RATE', 'AMORTIZATION', 'LOAN_AMOUNT'].includes(key)) {
            const interestRate = percentToNumber(data.INTEREST_RATE);
            const amortization = priceToInt(data.AMORTIZATION);
            const loanAmount = priceToInt(data.LOAN_AMOUNT);
            data.ANNUAL_LOAN_PAYMENT = interestRate !== false && amortization !== false && loanAmount !== false ? (-pmtFunction(interestRate / 100 / 12, amortization * 12, loanAmount) * 12).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0}) : '';
            loanPaymentChanged = true;
        }

        if (loanPaymentChanged || 'NET_OPERATING_INCOME' === key) {
            const noi = priceToInt(data.NET_OPERATING_INCOME);
            const loanPayment = priceToInt(data.ANNUAL_LOAN_PAYMENT);
            data.CASH_FLOW = noi !== false && loanPayment !== false ? (noi - loanPayment).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0}) : '';
            data.DSCR = noi !== false && loanPayment !== false ? loanPayment ? (noi / loanPayment).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0 : '';
            cashFlowChanged = true;
        }

        if (cashFlowChanged || downPaymentChanged) {
            const cashFlow = priceToInt(data.CASH_FLOW);
            const downPayment = priceToInt(data.DOWN_PAYMENT);
            data.CASH_ON_CASH = cashFlow !== false && downPayment !== false ? downPayment ? (cashFlow / downPayment * 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0 : '';
        }

        if (['CLOSE_OF_ESCROW', 'TERM'].includes(key)) {
            const closeOfEscrow = data.CLOSE_OF_ESCROW && !isNaN(new Date(data.CLOSE_OF_ESCROW))? new Date(data.CLOSE_OF_ESCROW) : false;
            const term = data.TERM ? parseInt(data.TERM) : false;
            data.MATURITY_DATE = '';
            if (closeOfEscrow !== false && term !== false) {
                closeOfEscrow.setFullYear(closeOfEscrow.getFullYear() + term);
                data.MATURITY_DATE = dateToUsString(closeOfEscrow);
            }
        }

        if (addAdditionalData) {
            data[addAdditionalData] = additionalDataValue;
        }

        this.setState({data: data});
    }

    handleChangeInput(key, value) {
        if (value === undefined) {
            this.setData(key, !this.state.data[key]);
        } else {
            const isAgentPercent = agentKeyPercents.includes(key);
            this.setData(key, value, isAgentPercent);
        }
    }

    handleChangeDropdown(query, queryType, x, key, key2) {
        const isAgentPercent = agentKeyPercents.includes(key);
        if (["LISTING_AGENT_4", "BUYER_AGENT_4"].includes(key))
            this.setData(key, query[key], isAgentPercent, key + "_FIRM", query[key + "_FIRM"]);
        else if (key === "SELLER_ID") {
            this.setState({sellerSelected: true}, () =>
                this.setData(key, query[key], isAgentPercent)
            );
        } else this.setData(key, query[key], isAgentPercent, key2, query[key2]);
    }

    handleSellerChangeInput(key, value) {
        this.setState({seller: {...this.state.seller, [key]: value}});
    }

    handleSellerChangeDropdown(query, queryType, x, key) {
        if (key === "SELLER_ID") {
            this.setState({sellerSelected: true}, () =>
                this.setData(key, query[key])
            );
        } else this.setState({seller: {...this.state.seller, [key]: query[key]}});
    }

    getTenantsForTags(tenantIds) {
        if (!tenantIds) {
            return [];
        }

        let formattedQueryValues = tenantIds.split(",");
        let response = [];

        // Display only first 5 tenants by sqft
        const tenantsBySQFT = this.state.tenantsBySQFT;
        const allTenantsById = this.state.allTenantsById;
        response = formattedQueryValues ? formattedQueryValues
                .filter((x) => {
                    if (allTenantsById[x] && allTenantsById[x].NAME.toLowerCase() !== "vacant") {
                        return x;
                    }
                })
                .map((x) => {
                    const tenant = find(tenantsBySQFT, {TENANT_ID: x});
                    const sqft = tenant && tenant.RR_SQFT ? parseInt(tenant.RR_SQFT) : 0;
                    return {
                        ARCIMEDES_ROW_ID: x,
                        NAME: allTenantsById[x] ? allTenantsById[x].NAME : "",
                        SQFT: sqft,
                    };
                })
            : [];
        response.sort((a, b) => (a.SQFT > b.SQFT ? -1 : 1));
        response.splice(defaultVisibleTenants, response.length - defaultVisibleTenants);
        response.forEach((el) => {
            delete el.SQFT;
        });
        return response;
    }

    setValue(updates) {
        this.setState({data: {...this.state.data, ...updates}});
    }

    setDataFromFinancials({newData, savedTenants, newTenants}) {
        const state = {};
        if (newData)
            state.data = newData;
        if (newTenants && newTenants.length) {
            let tenants = this.state.allTenants || [];
            let tenantsById = this.state.allTenantsById || [];
            tenants = tenants.concat(newTenants);
            tenantsById = tenantsById.concat(newTenants);
            state.allTenants = tenants;
            state.allTenantsById = tenantsById;
        }
        if (newData || newTenants && newTenants.length) {
            this.setState(state);
            if (newData)
                this.checkCoordinatesAndSave(newData, this.state.original, savedTenants);
        }
    }

    openFinancialsSpreadsheet() {
        // create new empty property and the fetch the id to pass it to the underwriting
        if (!this.state.data.ARCIMEDES_ROW_ID) {
            this.setState({isBusy: true});
            const data = this.state.data;
            request(arc.path.api, {
                service: "arcimedes",
                action: "open.datasource.table.Data.updateByTableCode",
                params: [PROPERTIES, {
                    value: [data],
                },],
            }).then((res) => {
                if (res && res.success && Array.isArray(res.data) && res.data.length) {
                    const newData = this.state.data;
                    newData.ARCIMEDES_ROW_ID = res.data[0].ARCIMEDES_ROW_ID;
                    this.setState({
                        newPropertyId: res.data[0].ARCIMEDES_ROW_ID,
                        data: newData,
                        isBusy: null,
                        financialsSpreadsheetInView: true,
                    });
                } else {
                    this.setState({
                        isBusy: null,
                        error: res && res.message ? res.message : "Unspecified error",
                    });
                }
            });
        } else {
            this.setState({
                financialsSpreadsheetInView: true,
            });
        }
    }

    closeFinancialsSpreadsheet(notSaved, error) {
        this.setState({financialsSpreadsheetInView: false});

        if (this.props.isAgent) {
            const route = {
                pathname: "/list",
                search: "?SOURCE=STRIVE&STATUS=Active&TRANSACTION_TYPE=Investment+Sales",
            };
            if (error && !notSaved) {
                route.state = {error: error};
            }
            if (!error && !notSaved) {
                route.state = {success: "Saved"};
            }
            browserHistory.push(route);
        }

        // delete the new empty property in case nothing was saved
        if (notSaved && this.state.newPropertyId) {
            this.setState({isBusy: true});
            const data = this.state.data;
            data.ARCIMEDES_ROW_ID = this.state.newPropertyId;
            data.DELETED = "1";
            request(arc.path.api, {
                service: "arcimedes",
                action: "open.datasource.table.Data.updateByTableCode",
                params: [PROPERTIES, {
                    value: [data],
                },],
            }).then((res) => {
                if (res && res.success && Array.isArray(res.data) && res.data.length) {
                    data.DELETED = null;
                    this.setState({
                        data: data,
                        newPropertyId: null,
                        isBusy: null,
                    });
                } else {
                    this.setState({
                        isBusy: null,
                        error: res && res.message ? res.message : "Unspecified error",
                    });
                }
            });
        }
    }

    toggleDrawer() {
        this.setState((prevState) => ({showDrawer: !prevState.showDrawer}));
    }

    addNewItem(addNewItemType) {
        this.setState({addNewItemType}, this.toggleDrawer);
    }

    savedNewItem(newData, newFirm) {
        // select the new item id & close drawer
        const key = this.state.addNewItemType;
        const state = {
            data: {...this.state.data, [key]: newData.ARCIMEDES_ROW_ID},
        };
        switch (key) {
            case "SELLER_ID": {
                state.newSeller = newData;
                state.seller = {};
                sellerKeys.forEach(key => {
                    state.seller[key] = newData[key];
                });
                break;
            }
            case "BUYER_ID":
                state.newBuyer = newData;
                break;
            case "LISTING_AGENT_4":
                state.newAgent = newData;
                if (newFirm) {
                    state.newFirm = newFirm;
                    state.data["LISTING_AGENT_4_FIRM"] = newData.FIRM;
                } else {
                    state.data["LISTING_AGENT_4_FIRM"] = newData.FIRM;
                }
                break;
            case "BUYER_AGENT_4":
                state.newAgent = newData;
                if (newFirm) {
                    state.newFirm = newFirm;
                    state.data["BUYER_AGENT_4_FIRM"] = newData.FIRM;
                } else {
                    state.data["BUYER_AGENT_4_FIRM"] = newData.FIRM;
                }
                break;
            case "REFERRED_BY_ID":
                state.newAgent = newData;
                state.data["REFERRED_BY_TYPE"] = 'oa';
                break;
            case "LISTING_AGENT_4_FIRM":
                state.newFirm = newData;
                break;
            case "BUYER_AGENT_4_FIRM":
                state.newFirm = newData;
                break;
            case "LENDER_ID":
                state.newLender = newData;
                break;
        }
        this.setState(state, () => this.toggleDrawer());
    }

    getDrawerComponent() {
        const component = this.state.addNewItemType;

        switch (component) {
            case "SELLER_ID":
                return (
                    <SellerDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                    />
                );
            case "BUYER_ID":
                return (
                    <BuyerDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                    />
                );
            case "LISTING_AGENT_4":
            case "BUYER_AGENT_4":
            case "REFERRED_BY_ID":
                return (
                    <AgentDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                    />
                );
            case "LISTING_AGENT_4_FIRM":
            case "BUYER_AGENT_4_FIRM":
                return (
                    <FirmDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                    />
                );
            case "LENDER_ID":
                return (
                    <LenderDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                    />
                );
        }
    }

    redirectToEscrowTracking() {
        const id = this.state.data.ARCIMEDES_ROW_ID;
        browserHistory.push({
            pathname: `${arc.path.base}escrow-tracking/${id}`,
            state: id
        });
    }

    redirectToHscTracking() {
        const id = this.state.data.ARCIMEDES_ROW_ID;
        browserHistory.push({
            pathname: `${arc.path.base}hsc-tracking/${id}`,
            state: id
        });
    }

    getTabs({data, historyData, isAgent, seller, edit, isReferral, isFinancing, isStriveFinancing}) {
        const tabs = [{
            name: "PROPERTY",
            renderedComponent: (
                <PropertyInfo
                    isAgent={isAgent}
                    data={data}
                    handleChangeDropdown={this.handleChangeDropdown}
                    handleChangeInput={this.handleChangeInput}
                    getTenantsForTags={this.getTenantsForTags}
                    viewMode={this.state.viewMode}
                    deleted={data && data.DELETED === "1"}
                    isReferral={isReferral}
                    isFinancing={isFinancing}
                    isStriveFinancing={isStriveFinancing}
                    redirectToHscTracking={this.redirectToHscTracking}
                />
            ),
        }];

        if (isFinancing) {
            tabs.push({
                name: "FINANCIALS",
                renderedComponent: (
                    <PropertyFinancials
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        openFinancialsSpreadsheet={this.openFinancialsSpreadsheet}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        isFinancing
                    />
                ),
            }, {
                name: "OWNERSHIP",
                renderedComponent: (
                    <OwnershipInfo
                        isAgent={isAgent}
                        seller={seller}
                        data={data}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleSellerChangeDropdown={this.handleSellerChangeDropdown}
                        handleSellerChangeInput={this.handleSellerChangeInput}
                        addNewItem={this.addNewItem}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        edit={edit}
                        sellerSelected={this.state.sellerSelected}
                        newSeller={this.state.newSeller}
                        newBuyer={this.state.newBuyer}
                        isFinancing
                    />
                ),
            }, {
                name: "BUYSIDE AGENT",
                renderedComponent: (
                    <BuysideAgent
                        data={data}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeInput={this.handleChangeInput}
                        addNewItem={this.addNewItem}
                        newAgent={this.state.newAgent}
                        newBuyer={this.state.newBuyer}
                        newFirm={this.state.newFirm}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        isFinancing
                    />
                ),
            }, {
                name: "LISTING AGENT",
                renderedComponent: (
                    <ListingAgent
                        data={data}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeInput={this.handleChangeInput}
                        addNewItem={this.addNewItem}
                        newAgent={this.state.newAgent}
                        newFirm={this.state.newFirm}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                    />
                ),
            }, {
                name: "LOAN INFO",
                renderedComponent: (
                    <Loan
                        isAgent={isAgent}
                        data={data}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeInput={this.handleChangeInput}
                        addNewItem={this.addNewItem}
                        newLender={this.state.newLender}
                        newAgent={this.state.newAgent}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                    />
                ),
            }, {
                name: "SALE INFO",
                renderedComponent: (
                    <SaleInformation
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        isFinancing
                    />
                ),
            });
        } else if (isReferral) {
            tabs.push({
                name: "REP AGREEMENT",
                renderedComponent: (
                    <RepresentationAgreement
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                    />
                ),
            }, {
                name: "SALE INFO",
                renderedComponent: (
                    <SaleInformation
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        isReferral
                    />
                ),
            });
        } else {
            tabs.push({
                name: "LISTING AGENT",
                renderedComponent: (
                    <ListingAgent
                        data={data}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeInput={this.handleChangeInput}
                        addNewItem={this.addNewItem}
                        newAgent={this.state.newAgent}
                        newFirm={this.state.newFirm}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                    />
                ),
            }, {
                name: "REP AGREEMENT",
                renderedComponent: (
                    <RepresentationAgreement
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                    />
                ),
            }, {
                name: "FINANCIALS",
                renderedComponent: (
                    <PropertyFinancials
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        openFinancialsSpreadsheet={this.openFinancialsSpreadsheet}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                    />
                ),
            }, {
                name: "OWNERSHIP",
                renderedComponent: (
                    <OwnershipInfo
                        isAgent={isAgent}
                        seller={seller}
                        data={data}
                        handleSellerChangeDropdown={this.handleSellerChangeDropdown}
                        handleSellerChangeInput={this.handleSellerChangeInput}
                        addNewItem={this.addNewItem}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        edit={edit}
                        sellerSelected={this.state.sellerSelected}
                        newSeller={this.state.newSeller}
                    />
                ),
            }, {
                name: "IN NEG/UNDER CONTRACT",
                    renderedComponent: (
                    <InNegotiationUnderContract
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        handleChangeDropdown={this.handleChangeDropdown}
                        redirectToEscrowTracking={this.redirectToEscrowTracking}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        isStriveFinancing={isStriveFinancing}
                    />
                ),
            }, {
                name: "BUYSIDE AGENT",
                renderedComponent: (
                    <BuysideAgent
                        data={data}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeInput={this.handleChangeInput}
                        addNewItem={this.addNewItem}
                        newAgent={this.state.newAgent}
                        newBuyer={this.state.newBuyer}
                        newFirm={this.state.newFirm}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                    />
                ),
            }, {
                name: "SALE INFO",
                renderedComponent: (
                    <SaleInformation
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        isStriveFinancing={isStriveFinancing}
                    />
                ),
            });

            if (isStriveFinancing)
                tabs.push({
                    name: "LOAN INFO",
                    renderedComponent: (
                        <Loan
                            isAgent={isAgent}
                            data={data}
                            handleChangeDropdown={this.handleChangeDropdown}
                            handleChangeInput={this.handleChangeInput}
                            addNewItem={this.addNewItem}
                            newLender={this.state.newLender}
                            newAgent={this.state.newAgent}
                            viewMode={this.state.viewMode}
                            deleted={data && data.DELETED === "1"}
                        />
                    ),
                });

            if (!isFinancing) {
                tabs.push({
                    name: "HISTORY",
                    className: 'property-history',
                    renderedComponent: (
                        <PropertyHistory
                            data={historyData}
                            deleted={data && data.DELETED === "1"}
                        />
                    )
                })
            }

            tabs.push({
                name: "WEBSITE",
                renderedComponent: (
                    <Website
                        isAgent={isAgent}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                    />
                ),
            })
        }

        return tabs;
    }

    render() {
        const {data, seller, historyData} = this.state;
        const isAgent = this.props.isAgent;
        const isSuper = this.props.isSuper;
        const email = this.props.userData ? this.props.userData.email : "";
        const {edit} = this.props;
        const isReferral = data && data.TRANSACTION_TYPE === 'Referral';
        const isFinancing = data && data.TRANSACTION_TYPE === 'Financing';
        const isStriveFinancing = data && data.HSC_FINANCING;

        return (
            <CRUD
                tabsData={this.getTabs({data, historyData, isAgent, seller, edit, isReferral, isFinancing, isStriveFinancing})}
                currentPageRef={this.currentPageRef}
                drawer={
                    <Drawer
                        isOpen={this.state.showDrawer}
                        shouldDisplayChildDrawer={true}
                        reff={this.drawerComponentRef}
                        closeDrawer={this.closeDrawer}
                    >
                        {this.getDrawerComponent()}
                    </Drawer>
                }
                backLink={`${arc.path.base}list?SOURCE=STRIVE&STATUS=Active&TRANSACTION_TYPE=Investment+Sales`}
                edit={edit}
                state={this.state}
                setState={this.setState.bind(this)}
                handleSubmit={this.handleSubmit}
                saveData={this.saveData}
                extraHeaderInfo={
                    !isReferral && (
                        isFinancing ?
                            <Dropdown
                                className="CRUD_content_status"
                                viewClassName="CRUD_content_status_view"
                                data={data}
                                isFromProperty
                                optionsType='status-financing'
                                value={data && data.HSC_STATUS}
                                valueKey="HSC_STATUS"
                                disabled={isAgent}
                                handleParentChange={this.handleChangeDropdown}
                                viewMode={this.state.viewMode}
                                deleted={this.state.deleted}
                            />
                            :
                            <Dropdown
                                className="CRUD_content_status"
                                viewClassName="CRUD_content_status_view"
                                optionKey='code'
                                optionLabelKey='code'
                                data={data}
                                isFromProperty
                                optionsType='status'
                                value={data && data.STATUS}
                                valueKey="STATUS"
                                disabled={isAgent}
                                handleParentChange={this.handleChangeDropdown}
                                viewMode={this.state.viewMode}
                                deleted={this.state.deleted}
                            />
                    )
                }
                extraInfo={
                    edit && data ? (
                        <div className="CRUD_content_info">
                            <div>
                                Date created: <span>{data.DATE_CREATED}</span>
                            </div>
                            <div>
                                Created by: <span>{data.CREATED_BY}</span>
                            </div>
                            <div>
                                Last modified: <span>{data.LAST_MODIFIED_DATE}</span>
                            </div>
                            <div>
                                Modified by: <span>{data.LAST_MODIFIED_BY}</span>
                            </div>
                        </div>
                    ) : null
                }
                type="property"
                backName="PROPERTIES"
                title={data && `${data.NAME} - ${data.CITY ? data.CITY : ''}, ${data.STATE ? data.STATE : ''}`}
                isAgent={isAgent}
                formattedOriginalData={convertDataToForm(this.state.original)}
            >
                {this.state.financialsSpreadsheetInView ? (
                    <Financials
                        location={this.props.location}
                        data={data}
                        newPropertyId={this.state.newPropertyId}
                        allTenantsById={this.state.allTenantsById}
                        parentSetData={this.setDataFromFinancials}
                        isAgent={isAgent}
                        isSuper={isSuper}
                        email={email}
                        close={this.closeFinancialsSpreadsheet}
                    />
                ) : null}
            </CRUD>
        );
    }
}
